import React from 'react';
import styled from 'styled-components';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import AdminBlockWithSortVisible from '../../share/component/AdminBlockWithSortVisible';
import { useAdminMember } from '../../share/hook/useAdminMember';
import { useAdminMemberListStore } from '../../share/store/adminMemberStore';
import { MemberSortOrder, SortDirection } from '../../../shared/enum/EnumRepository';

const MemberColumnInfo: React.FC = () => {
  const { activeMember } = useAdminMember();
  const { sortData, setSortData } = useAdminMemberListStore();

  const handleDirectionChange = (field: MemberSortOrder) => {
    if (sortData.sort === field) {
      setSortData({
        ...sortData,
        direction: sortData.direction === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC,
      });
    } else {
      setSortData({ sort: field, direction: SortDirection.ASC });
    }
  };

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <TitleBlock onClick={() => handleDirectionChange(MemberSortOrder.USERNAME)}>
          Username

          <SelectDirection
            $isASC={
              sortData.sort === MemberSortOrder.USERNAME &&
              sortData.direction === SortDirection.ASC
            }
            $isSortField={sortData.sort === MemberSortOrder.USERNAME}
          >
            ▼
          </SelectDirection>
        </TitleBlock>
        <AdminBlockWithVisible
          width={"1.1"}
          isColumn={true}
          value={"Type"}
        />
        <AdminBlockWithSortVisible
          width={'1.5'}
          isColumn={true}
          value={'Last login'}
          isASC={
            sortData.sort === MemberSortOrder.LAST_LOGIN_AT
            && sortData.direction === SortDirection.ASC
          }
          isSortField={sortData.sort === MemberSortOrder.LAST_LOGIN_AT}
          handleDirectionChange={() =>
            handleDirectionChange(MemberSortOrder.LAST_LOGIN_AT)
          }
        />
        <AdminBlockWithVisible
          width={"1.5"}
          isColumn={true}
          value={"Handle"}
        />
        <AdminBlockWithVisible
          width={"1.2"}
          isColumn={true}
          value={"Exposure"}
        />
        <AdminBlockWithVisible
          width={"1.3"}
          isColumn={true}
          value={"Subscription"}
        />
        <AdminBlockWithVisible
          width={'1.5'}
          isColumn={true}
          value={'Storage Usage'}
        />
        {activeMember && <SpaceBlock />}
      </InfoContainer>
      {activeMember &&
        <OverviewBlock>Overview</OverviewBlock>
      }
    </ColumnInfoComp>
  );
};


const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};

  ${({ theme }) => theme.typography.Body_03_2};
`;
const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;

const TitleBlock = styled.div`
  flex: 2.5;
  display: flex;
  align-items: center;
  padding-left: 10px;
  cursor: pointer;
  user-select: none;
`;

const SelectDirection = styled.span<{ $isSortField: boolean; $isASC: boolean }>`
  margin-left: 4px;
  user-select: none;
  ${({ theme }) => theme.typography.Footer_02};
  color: ${({ theme, $isSortField }) =>
    $isSortField ? theme.colors.color_Gray_03 : theme.colors.color_Gray_05};
  transform: ${({ $isASC, $isSortField }) => {
    if (!$isSortField) return 'scale(0.7)';
    return $isASC ? 'scale(0.7)' : 'scaleY(-1) scale(0.7)';
  }};
  transition: transform 0.6s ease-in-out;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`

const OverviewBlock = styled.div`
  width: 29vw;
  display: flex;
  align-items: center;
`

export default MemberColumnInfo;
